export const AUTO_SCROLL_TO_LAST_ACTIVE = true;
export const ALLOW_ONLY_ONE_OPENED = false;
export const SIZE = 'XS';
export const TEST_ID = 'accordion';